export default function (number: any) {
  const num = sanitizePhoneNumber(number)
  if (num.indexOf('+') === 0 || num.length !== 10) return number
  else return '+1' + num
}
